(() => {
  const CFG = {
    sectionId: "main-collection-product-grid",
    gridSelector: "#product-grid",
    itemSelectors: ["li.grid__item", ".grid__item"],
    storageKey: "bb_collection_active_cat",
    debug: true
  };

  const log = (...a) => CFG.debug && console.log("[BB PILLS]", ...a);
  const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();

  const VALID_CATS = new Set([
    "all",
    "bb_cat_engine",
    "bb_cat_exhaust",
    "bb_cat_suspension",
    "bb_cat_aero",
    "bb_cat_body",
    "bb_cat_interior",
    "bb_wheel"
  ]);

  // ✅ pills may be "handling/wheels/interior" — map to canonical cats for sorting
  const CAT_ALIASES = {
    all: "all",
    engine: "bb_cat_engine",
    exhaust: "bb_cat_exhaust",
    handling: "bb_cat_suspension",
    suspension: "bb_cat_suspension",
    aero: "bb_cat_aero",
    body: "bb_cat_body",
    interior: "bb_cat_interior",
    wheels: "bb_wheel",
    wheel: "bb_wheel"
  };

  const canonCat = (raw) => {
    const c = norm(raw || "all");
    if (VALID_CATS.has(c)) return c;
    const aliased = CAT_ALIASES[c] || c;
    return VALID_CATS.has(aliased) ? aliased : "all";
  };

  // ✅ FIX: active styling ONLY uses .is-active (NOT aria-pressed)
  const PILL_CSS = `
/* ===== BB Category Pills (Injected) ===== */
.bb-pills, [data-bb-pills]{
  display:flex !important;
  flex-wrap:wrap !important;
  gap:10px !important;
  align-items:center !important;
  margin:12px 0 0 !important;
}

.bb-pill{
  appearance:none !important;
  -webkit-appearance:none !important;
  display:inline-flex !important;
  align-items:center !important;
  gap:8px !important;
  padding:8px 12px !important;
  border-radius:999px !important;

  border:1px solid rgba(255,255,255,0.14) !important;
  background: rgba(0,0,0,0.55) !important;
  color: rgba(255,255,255,0.92) !important;

  font-size:12.5px !important;
  line-height:1 !important;
  letter-spacing:.02em !important;
  text-transform:uppercase !important;
  text-decoration:none !important;

  user-select:none !important;
  -webkit-font-smoothing:antialiased !important;
  backdrop-filter: blur(6px) !important;
  -webkit-backdrop-filter: blur(6px) !important;

  box-shadow:
    0 0 0 1px rgba(0,0,0,0.35) inset,
    0 8px 22px rgba(0,0,0,0.35) !important;

  transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease, background 140ms ease !important;
  cursor:pointer !important;
}

.bb-pill::before{
  content:"" !important;
  width:7px !important;
  height:7px !important;
  border-radius:50% !important;
  background: rgba(255,120,0,0.95) !important;
  box-shadow: 0 0 0 2px rgba(255,120,0,0.18) !important;
  flex: 0 0 auto !important;
}

.bb-pill:hover{
  transform: translateY(-1px) !important;
  border-color: rgba(255,120,0,0.35) !important;
  box-shadow:
    0 0 0 1px rgba(255,120,0,0.14) inset,
    0 10px 26px rgba(0,0,0,0.45) !important;
  background: rgba(0,0,0,0.68) !important;
}

.bb-pill.is-active{
  border-color: rgba(255,120,0,0.55) !important;
  background: rgba(12,8,4,0.85) !important;
  box-shadow:
    0 0 0 1px rgba(255,120,0,0.18) inset,
    0 0 18px rgba(255,120,0,0.18),
    0 12px 28px rgba(0,0,0,0.55) !important;
}

.bb-pill.is-active::before{
  background: rgba(255,140,30,1) !important;
  box-shadow:
    0 0 0 2px rgba(255,140,30,0.24) !important,
    0 0 14px rgba(255,140,30,0.30) !important;
}

/* ===== BB Loading Indicator ===== */
.bb-loading{
  display:none;
  align-items:center;
  gap:10px;
  margin:10px 0 0 !important;
  color: rgba(255,255,255,0.72);
  font-size:12px;
  letter-spacing:.02em;
  text-transform:uppercase;
}
.bb-loading.is-on{ display:inline-flex; }
.bb-loading .bb-spinner{
  width:14px;
  height:14px;
  border-radius:999px;
  border:2px solid rgba(255,255,255,0.18);
  border-top-color: rgba(255,122,24,0.95);
  animation: bbspin .8s linear infinite;
}
@keyframes bbspin { to { transform: rotate(360deg); } }

/* ===== BB Collection Search (Injected) ===== */
.bb-collection-search{
  width:100%;
  margin: 14px 0 18px !important;
}
.bb-collection-search input{
  width:100%;
  padding:12px 14px;
  font-size:15px;
  border-radius:10px;
  border:1px solid rgba(255,255,255,0.12);
  background:#0b0b0b;
  color:#fff;
  outline:none;
  transition:border-color .2s ease, box-shadow .2s ease;
}
.bb-collection-search input::placeholder{
  color: rgba(255,255,255,0.45);
}
.bb-collection-search input:focus{
  border-color:#ff7a18;
  box-shadow: 0 0 0 1px rgba(255,122,24,0.35);
}
`;

  const injectCss = () => {
    if (document.getElementById("bb-pill-style")) return;
    const style = document.createElement("style");
    style.id = "bb-pill-style";
    style.textContent = PILL_CSS;
    document.head.appendChild(style);
    log("Injected pill CSS");
  };

  const findPillsWrap = () => {
    let wrap =
      document.querySelector("[data-bb-pills]") ||
      document.querySelector(".bb-pills") ||
      document.querySelector(".bb-pills-wrap");

    if (wrap) return wrap;

    wrap = document
      .querySelector(".collection")
      ?.querySelector("[data-bb-cat]")
      ?.closest("div, nav, section") || null;

    return wrap;
  };

  // ✅ Insert loading indicator just under pills (once)
  const ensureLoading = (wrap) => {
    if (!wrap) return;
    if (document.getElementById("bbPillsLoading")) return;

    const el = document.createElement("div");
    el.className = "bb-loading";
    el.id = "bbPillsLoading";
    el.innerHTML = `<span class="bb-spinner" aria-hidden="true"></span><span>Loading…</span>`;

    wrap.insertAdjacentElement("afterend", el);
    log("Inserted loading indicator");
  };

  const setLoading = (on) => {
    const el = document.getElementById("bbPillsLoading");
    if (!el) return;
    el.classList.toggle("is-on", !!on);
  };

  // ✅ Insert search bar just under pills (once) — BUT after loader if present
  const ensureSearchBar = (wrap) => {
    if (!wrap) return;
    if (document.getElementById("bbCollectionSearch")) return;

    const holder = document.createElement("div");
    holder.className = "bb-collection-search";
    holder.innerHTML = `
      <input
        type="text"
        id="bbCollectionSearch"
        placeholder="Search within this collection…"
        autocomplete="off"
      />
    `;

    const loader = document.getElementById("bbPillsLoading");
    if (loader && loader.parentNode) loader.insertAdjacentElement("afterend", holder);
    else wrap.insertAdjacentElement("afterend", holder);

    log("Inserted collection search bar");
  };

  const normalizePillsDom = () => {
    const wrap = findPillsWrap();
    if (!wrap) {
      log("No pills wrapper found yet");
      return null;
    }

    wrap.classList.add("bb-pills");
    wrap.setAttribute("data-bb-pills", "true");

    const pills = Array.from(wrap.querySelectorAll("[data-bb-cat]"));
    if (!pills.length) {
      log("Wrapper found, but no [data-bb-cat] pills inside");
      ensureLoading(wrap);
      ensureSearchBar(wrap);
      return wrap;
    }

    pills.forEach((el) => {
      el.classList.add("bb-pill");
      el.setAttribute("role", "button");
      if (el.tagName === "BUTTON" && !el.getAttribute("type")) el.setAttribute("type", "button");
    });

    ensureLoading(wrap);
    ensureSearchBar(wrap);
    log("Normalized pills:", pills.length);
    return wrap;
  };

  const getGrid = () => document.querySelector(CFG.gridSelector);

  const qsaFirst = (selectors, root) => {
    for (const s of selectors) {
      const els = Array.from(root.querySelectorAll(s));
      if (els.length) return els;
    }
    return [];
  };

  const getTagsFromItem = (item) => {
    const node = item.querySelector("[data-bb-tags]") || item;
    const raw = node.getAttribute?.("data-bb-tags") || "";
    return raw.split(",").map(norm).filter(Boolean);
  };

  // ✅ SAFE title grab — if missing, returns ""
  const getTitleFromItem = (item) => {
    const tEl =
      item.querySelector(".card__heading a") ||
      item.querySelector(".card__heading") ||
      item.querySelector(".card__information a") ||
      item.querySelector("a.full-unstyled-link") ||
      item.querySelector("a");
    return norm(tEl?.textContent || "");
  };

  // ===== Keywords (SECONDARY ONLY) =====
  // ✅ Fixes:
  //  - negatives are a HARD GATE, positives are secondary qualification
  //  - aero overrides body when aero terms are present
  //  - global per-category "VETO" blocks polluted tags (even if the product has the tag)
  const KW = {
    bb_cat_engine: {
      strong: [
        "intake","cold air","short ram","air intake","airbox","air box","inlet",
        "intercooler","charge pipe","boost pipe","turbo inlet","bov","blow off",
        "fuel pump","injector","injectors","fuel rail","catch can","oil cooler","radiator",
        "engine mount","motor mount"
      ],
      soft: ["throttle body","maf","map sensor","heat exchanger","thermostat","breather"],
      neg: [
        "exhaust","catback","downpipe","midpipe","muffler","axleback","axle back","header","manifold",
        "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
        "wheel","wheels","rim","rims","tire","tires",
        "wing","spoiler","splitter","diffuser","canard","canards","side skirt","side skirts","undertray","front lip","lip",
        "seat","seats","shift knob","shifter","steering wheel","floor mat","floor mats"
      ]
    },

    bb_cat_exhaust: {
      strong: [
        "exhaust","catback","axleback","axle back","downpipe","midpipe",
        "header","headers","manifold","muffler","resonator","test pipe","front pipe","y pipe","ypipe"
      ],
      soft: ["cat delete","cat-delete","catalytic"],
      neg: [
        "intake","intercooler","charge pipe","boost pipe","fuel pump","injector","injectors","catch can","radiator","oil cooler",
        "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
        "wheel","wheels","rim","rims","tire","tires",
        "seat","seats","shifter","wing","splitter","diffuser","canard"
      ]
    },

    bb_cat_suspension: {
      strong: [
        "coilover","coil over","lowering spring","lowering springs","spring","springs",
        "shock","strut","damper",
        "sway bar","anti roll","anti-roll","endlink","end link",
        "control arm","camber","toe","caster","bushing","bushings",
        "chassis brace","tower brace","strut bar"
      ],
      soft: ["alignment","roll center","roll-center","subframe"],
      neg: [
        "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
        "wheel","wheels","rim","rims","tire","tires",
        "intake","intercooler","charge pipe","exhaust","catback","downpipe",
        "wing","splitter","diffuser","bumper","hood","seat","seats","shifter"
      ]
    },

    bb_cat_aero: {
      strong: [
        "wing","spoiler","splitter","front lip","lip","canard","canards",
        "diffuser","side skirt","side skirts","skirt","skirts",
        "undertray","aero"
      ],
      soft: ["vortex","air dam"],
      neg: [
        "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
        "wheel","wheels","rim","rims","tire","tires",
        "seat","seats","shifter","intake","intercooler","exhaust","downpipe",
        "hood","fender","quarter panel","door","trunk","hatch","brakes","tow hook","rod bearing","wilwood"
      ]
    },

    bb_cat_body: {
      strong: [
        "bumper","hood","fender","quarter panel","quarterpanel",
        "widebody","wide body","overfender","over fender",
        "door","trunk","hatch","grille","grill",
        "body kit","bodykit","mirror cover","spoiler","lip","diffuser","roof","trunk"
      ],
      soft: ["valance","grille","grill"],
      neg: [
        "wing","spoiler","splitter","diffuser","canard","canards","side skirt","side skirts","undertray","front lip","lip",
        "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
        "wheel","wheels","rim","rims","tire","tires",
        "intake","intercooler","charge pipe","exhaust","downpipe",
        "seat","seats","shifter","steering wheel","floor mat","floor mats","tow hook"
      ]
    },

    bb_cat_interior: {
      strong: [
        "seat","seats","bucket","recaro",
        "steering wheel",
        "shift knob","shifter","short shifter",
        "floor mat","floor mats","floor liner","floor liners",
        "interior","trim","console","dash","panel","pedal","pedals"
      ],
      soft: ["boot","armrest","gauge","cluster"],
      neg: [
        "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
        "wheel","wheels","rim","rims","tire","tires",
        "intake","intercooler","charge pipe","exhaust","downpipe",
        "wing","spoiler","splitter","diffuser","bumper","hood","fender",
        "coilover","spring","springs","sway bar","control arm","damper"
      ]
    },

    bb_wheel: {
      strong: [
        "wheel","wheels","rim","rims","forged wheel","cast wheel","monoblock",
        "lug nut","lug nuts","center cap","centre cap",
        "wheel spacer","wheel spacers","spacer","spacers","hub ring","hubring"
      ],
      soft: ["bolt pattern","pcd","5x100","5x114","5x114.3"],
      neg: [
        "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
        "tire","tires",
        "clutch","flywheel","disc","pressure plate","throwout","throw-out","release bearing",
        "coilover","spring","springs","sway bar","control arm",
        "bearing","bearings",
        "intake","intercooler","charge pipe","fuel pump","injector","injectors","exhaust","downpipe"
      ]
    }
  };

  // Aero overrides body if ANY aero term appears
  const AERO_TERMS = [
    "wing","spoiler","splitter","front lip","lip","canard","canards",
    "diffuser","side skirt","side skirts","undertray","aero","skirt","skirts"
  ];

  const includesAny = (t, arr) => (arr || []).some((k) => t.includes(k));
  const countHits = (t, arr) => (arr || []).reduce((n, k) => n + (t.includes(k) ? 1 : 0), 0);

  // ✅ VETO: CLEAN UP polluted tags (even if product has the tag)
  // This is the mitigation layer that prevents “wrong bb tag” products from rising under a pill.
  const VETO = {
    bb_cat_engine: [
      "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
      "wheel","wheels","rim","rims","tire","tires",
      "wing","spoiler","splitter","diffuser","canard","side skirt","undertray","front lip",
      "seat","seats","shift knob","shifter","steering wheel","floor mat"
    ],
    bb_cat_exhaust: [
      "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
      "wheel","wheels","rim","rims","tire","tires",
      "seat","seats","shift knob","shifter","steering wheel","floor mat",
      "wing","spoiler","splitter","diffuser","canard","side skirt","undertray"
    ],
    bb_cat_suspension: [
      "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
      "wheel","wheels","rim","rims","tire","tires",
      "intake","intercooler","charge pipe","fuel pump","injector","injectors",
      "exhaust","catback","downpipe","muffler","header",
      "seat","seats","shift knob","shifter","steering wheel","floor mat",
      "wing","spoiler","splitter","diffuser","canard","side skirt","undertray","engine","radiator","connecting rods","clutch","rack and pinion","anti lift","drive shaft","steering","lsd","accelerator pedal"
    ],
    bb_cat_aero: [
      "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
      "wheel","wheels","rim","rims","tire","tires",
      "intake","intercooler","charge pipe","fuel pump","injector","injectors",
      "exhaust","catback","downpipe","muffler","header",
      "seat","seats","shift knob","shifter","steering wheel","floor mat","wilwood","tow hook","rod bearing","trunk","roof","hood"
    ],
    bb_cat_body: [
      "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
      "wheel","wheels","rim","rims","tire","tires",
      "intake","intercooler","charge pipe","fuel pump","injector","injectors",
      "exhaust","catback","downpipe","muffler","header",
      "seat","seats","shift knob","shifter","steering wheel","floor mat","bearing","reverse lockout","brembo","pulley","brace","clutch","diode","tank","cam sensor","rod bearing","throttle body","clutch","lockout kit","hella","torque solution","stoptech","piston","bushing","hose","gasket"
    ],
    bb_cat_interior: [
      "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
      "wheel","wheels","rim","rims","tire","tires",
      "intake","intercooler","charge pipe","fuel pump","injector","injectors",
      "exhaust","catback","downpipe","muffler","header",
      "wing","spoiler","splitter","diffuser","canard","side skirt","undertray","front lip",
      "bumper","hood","fender","widebody","overfender","grille","grill","damper"
    ],
    bb_wheel: [
      // wheels must never include brakes / clutch / engine/exhaust stuff
      "brake","brakes","rotor","rotors","pad","pads","caliper","calipers","bbk","big brake","brake kit","brakekit",
      "tire","tires",
      "clutch","flywheel","disc","pressure plate","throwout","throw-out","release bearing",
      "intake","intercooler","charge pipe","fuel pump","injector","injectors","oil cooler","radiator",
      "exhaust","catback","downpipe","midpipe","muffler","header","manifold",
      "seat","seats","shift knob","shifter","steering wheel","floor mat",
      "wing","spoiler","splitter","diffuser","canard","side skirt","undertray",
      "bumper","hood","fender","fan","filter","engine","knob","injector","diode","differential","belt","bushing","transmission","brace","throttle body","exhaust"
    ]
  };

  // ✅ FIX: negatives gate first; require >=1 strong positive; soft only boosts
  const keywordScoreForCat = (title, cat) => {
    const rule = KW[cat];
    if (!rule || !title) return -1e9;

    // AERO override: if it's aero-ish, BODY cannot claim it
    if (cat === "bb_cat_body" && includesAny(title, AERO_TERMS)) return -1e9;

    // 1) hard negatives first
    if (includesAny(title, rule.neg)) return -1e9;

    // 2) must hit strong
    const strongHits = countHits(title, rule.strong);
    if (strongHits <= 0) return 0;

    // 3) soft is bonus only
    const softHits = countHits(title, rule.soft);
    return strongHits * 10 + softHits * 2;
  };

  // ✅ Score: VETO first (cleans polluted tags), tags second, keywords third
  const scoreItem = (item, catRaw) => {
    const cat = canonCat(catRaw);
    if (!cat || cat === "all") return 0;

    const title = getTitleFromItem(item);

    // ✅ CLEANUP LAYER: if title clearly contradicts category, it cannot rise even if tagged wrong
    if (VETO[cat] && includesAny(title, VETO[cat])) return 0;

    const tags = getTagsFromItem(item);
    if (tags.includes(norm(cat))) return 100;

    const kwScore = keywordScoreForCat(title, cat);
    if (kwScore <= 0) return 0;

    // keep keywords under tags
    return 60 + Math.min(30, kwScore);
  };

  // ✅ FIX: hard reset UI state every time (and remove stray active classes)
  const setActivePillUI = (cat) => {
    const want = canonCat(cat);

    document.querySelectorAll("[data-bb-cat]").forEach((el) => {
      const key = canonCat(el.getAttribute("data-bb-cat"));
      const on = key === want;

      // visual active is ONLY this class now
      el.classList.toggle("is-active", on);

      // accessibility only (no styling tied to it)
      el.setAttribute("aria-pressed", on ? "true" : "false");
      el.setAttribute("aria-selected", on ? "true" : "false");

      // kill common theme “active” markers so they don't visually conflict
      if (!on) {
        el.classList.remove("active", "is-selected", "selected", "current");
        el.removeAttribute("data-active");
      } else {
        el.setAttribute("data-active", "true");
      }
    });
  };

  const getStoredCat = () => {
    let cat = "all";
    try { cat = canonCat(sessionStorage.getItem(CFG.storageKey) || "all"); } catch (_) {}
    if (!VALID_CATS.has(cat)) cat = "all";
    return cat;
  };

  const syncUIFromStorage = () => {
    const cat = getStoredCat();
    setActivePillUI(cat);
    return cat;
  };

  const parseTotalProducts = () => {
    const candidates = [
      document.querySelector(".collection__title + *"),
      document.querySelector(".collection__title"),
      document.querySelector(".facets__heading"),
      document.querySelector("[class*='product-count']"),
      document.querySelector(".product-count")
    ].filter(Boolean);

    for (const el of candidates) {
      const txt = el.textContent || "";
      const m = txt.match(/(\d{1,6})\s*products?/i);
      if (m) return Number(m[1]);
    }
    return null;
  };

  const buildUrlForPage = (pageNum) => {
    const u = new URL(location.href);
    u.searchParams.set("page", String(pageNum));
    u.searchParams.set("section_id", CFG.sectionId);
    return u.toString();
  };

  const fetchSectionItems = async (pageNum) => {
    const url = buildUrlForPage(pageNum);
    const html = await fetch(url, { credentials: "same-origin" }).then((r) => r.text());
    const doc = new DOMParser().parseFromString(html, "text/html");
    const grid = doc.querySelector(CFG.gridSelector) || doc;
    return qsaFirst(CFG.itemSelectors, grid);
  };

  const PAGE_CACHE = new Map();

  const loadAllPages = async () => {
    const grid = getGrid();
    if (!grid) return [];

    const page1Items = qsaFirst(CFG.itemSelectors, grid);
    const perPage = page1Items.length || 24;

    const total = parseTotalProducts();
    const pages = total ? Math.ceil(total / perPage) : 10;

    log("perPage:", perPage, "total:", total, "pages:", pages);

    const all = [];
    all.push(...page1Items);

    for (let p = 2; p <= pages; p++) {
      if (PAGE_CACHE.has(p)) {
        all.push(...PAGE_CACHE.get(p));
        continue;
      }

      const items = await fetchSectionItems(p);
      if (!items.length) break;

      PAGE_CACHE.set(p, items);
      all.push(...items);
    }

    return all;
  };

  const renderAllThenReorder = async (catRaw) => {
    const grid = getGrid();
    if (!grid) return;

    const cat = canonCat(catRaw || "all");
    if (!VALID_CATS.has(cat)) {
      setActivePillUI("all");
      return;
    }

    setLoading(true);

    try {
      const items = await loadAllPages();

      if (cat === "all") {
        const frag = document.createDocumentFragment();
        items.forEach((el) => frag.appendChild(el));
        grid.innerHTML = "";
        grid.appendChild(frag);
        return;
      }

      const scored = items.map((it, idx) => ({ el: it, score: scoreItem(it, cat), idx }));
      scored.sort((a, b) => (b.score !== a.score ? b.score - a.score : a.idx - b.idx));

      // debug: hits
      const hits = scored.filter(x => x.score > 0).length;
      log("Reorder", cat, "hits:", hits, "total:", scored.length);

      const frag = document.createDocumentFragment();
      scored.forEach((s) => frag.appendChild(s.el));
      grid.innerHTML = "";
      grid.appendChild(frag);
    } finally {
      setLoading(false);
    }
  };

  const boot = () => {
    if (window.__BB_PILLS__?.mounted) return;
    window.__BB_PILLS__ = window.__BB_PILLS__ || {};
    window.__BB_PILLS__.mounted = true;

    injectCss();
    const wrap = normalizePillsDom();
    ensureLoading(wrap);
    ensureSearchBar(wrap);

    // keep UI state stable through Shopify re-renders
    let moTimer = null;
    const mo = new MutationObserver(() => {
      if (moTimer) clearTimeout(moTimer);
      moTimer = setTimeout(() => {
        const w = normalizePillsDom();
        ensureLoading(w);
        ensureSearchBar(w);
        syncUIFromStorage();
      }, 50);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    document.addEventListener(
      "pointerdown",
      (e) => {
        const pill = e.target.closest?.("[data-bb-cat]");
        if (!pill) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );

    document.addEventListener(
      "click",
      (e) => {
        const pill = e.target.closest?.("[data-bb-cat]");
        if (!pill) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const safeCat = canonCat(pill.getAttribute("data-bb-cat") || "all");
        try { sessionStorage.setItem(CFG.storageKey, safeCat); } catch (_) {}

        setActivePillUI(safeCat);
        renderAllThenReorder(safeCat);

        setTimeout(() => setActivePillUI(safeCat), 0);
        setTimeout(() => setActivePillUI(safeCat), 80);
      },
      true
    );

    const cat = syncUIFromStorage();
    if (cat !== "all") renderAllThenReorder(cat);

    log("Booted. Active:", cat);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();

/* ============================================================
   Collection Search (Local filter under pills)
   - inserts search bar (if not present)
   - filters visible items in current grid (no reload)
   - survives reorder / pagination fetch by re-caching on grid mutation
   ============================================================ */
(() => {
  const INPUT_ID = "bbCollectionSearch";
  const GRID_ID = "product-grid";
  const ITEM_SELECTORS = ["li.grid__item", ".grid__item"];
  const log = (...a) => console.log("[BB SEARCH]", ...a);
  const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();

  const getItems = () => {
    const out = [];
    ITEM_SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach((n) => out.push(n));
    });
    return out;
  };

  const extractText = (item) => {
    // uses optional dataset fields if you add them later, otherwise falls back to textContent
    return norm(
      [
        item.dataset.productTitle,
        item.dataset.productVendor,
        item.dataset.productTags,
        item.textContent
      ].join(" ")
    );
  };

  let cache = [];

  const buildCache = () => {
    cache = getItems().map((el) => ({ el, text: extractText(el) }));
  };

  const applySearch = (query) => {
    const q = norm(query);
    cache.forEach(({ el, text }) => {
      el.style.display = !q || text.includes(q) ? "" : "none";
    });
  };

  const attach = () => {
    const input = document.getElementById(INPUT_ID);
    if (!input) return;

    // avoid double binding
    if (input.__bbBound) return;
    input.__bbBound = true;

    buildCache();

    input.addEventListener("input", (e) => {
      applySearch(e.target.value);
    });

    const grid = document.getElementById(GRID_ID);
    if (grid) {
      new MutationObserver(() => {
        buildCache();
        applySearch(input.value);
      }).observe(grid, { childList: true, subtree: false });
    }

    log("Attached");
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach, { once: true });
  } else {
    attach();
  }
})();